import { MutationTree } from 'vuex'
import { SubscriptionsState } from './state'
import { Pass, Plan, Subscription, Invoice } from '../../types'

const mutations: MutationTree<SubscriptionsState> = {
  CURRENT_SUBSCRIPTIONS_UPDATED: (
    state,
    subscriptions: Array<Subscription>
  ) => {
    state.currentSubscriptions = subscriptions
  },

  CURRENT_INVOICES_UPDATED: (state, invoices: Array<Invoice>) => {
    state.currentInvoices = invoices
  },

  PASS_TYPES_UPDATED: (state, passes: Array<Pass>) => {
    state.passTypes = passes
  },

  AVAILABLE_PLANS_UPDATED: (state, plans: Array<Plan>) => {
    state.availablePlans = plans
  },

  CURRENT_ONE_TERM_PRICING_UPDATED: (state, pricing: object) => {
    state.addTermPricing = pricing
  },

  PLAN_COMPARISON_UPDATED: (state, comparison: object) => {
    state.currentPlanComparison = comparison
  },

  SUBSCRIPTION_UPGRADED: (state, plan: Subscription) => {
    if (state.currentSubscriptions && state.currentSubscriptions.length) {
      const filteredSubs = state.currentSubscriptions.filter(
        sub => sub.id !== plan.id
      )
      state.currentSubscriptions = [...filteredSubs, plan]
    }
  },

  PAYMENT_INFO_UPDATED: (
    state,
    payload: {
      account_credit: string
      payment_method_mask: string
      payment_method_object: string
    }
  ) => {
    const {
      account_credit,
      payment_method_mask,
      payment_method_object,
    } = payload
    state.paymentInfo = {
      last4_of_cc: payment_method_mask,
      account_credit,
      payment_method: payment_method_object,
    }
  },

  CANCELLATION_FIELDS_UPDATED: (state, fields: object) => {
    state.cancellationFields = fields
  },
}

export default mutations
